// -----------------------------------------------------------------------------
// Suche
// -----------------------------------------------------------------------------

import * as generalUtility from '../utility/generalUtility';

const init = () => {
  if ($('.js-body').hasClass('js-body-search') === false) {
    return;
  }

  initInitialState();
  initEventListeners();
};

/**
 * Formular-Elemente initial einrichten
 */
const initInitialState = () => {
  const trans = generalUtility.getJsonFromHtml('.js-body-search #trans');

  // Sumo-Select einrichten
  $('#phase, #branche, #form, #standort').SumoSelect({ // eslint-disable-line new-cap
    selectAll: true,
    placeholder: trans.bitte_waehlen,
    outputAsCSV: true,
    captionFormat: '{0} ' + trans.gewaehlt,
    captionFormatAllSelected: trans.alle_gewaehlt,
    locale: [trans.ok, trans.abbrechen, trans.alle_auswaehlen]
  });
};

/**
 * Slider abhängig von Type U/I einrichten
 */
const initEventListeners = () => {
  const vars = generalUtility.getJsonFromHtml('.js-body-search #vars');

  if (vars.type === 'I') {
    initSliderI();
  } else if (vars.type === 'U') {
    initSliderU();
  }
};

/**
 * Slider für Non-Startup einrichten
 */
const initSliderI = () => {
  const vars = generalUtility.getJsonFromHtml('.js-body-search #vars');
  const $sliderRange = $('#slider-range');

  $sliderRange.slider({
    range: true,
    min: 0,
    max: 5000000,
    step: 50000,
    values: [vars.sliderMinI, vars.sliderMaxI],
    slide: function (event, ui) {
      $('#kapitalbedarf').val(ui.values[0].toLocaleString() + ' € - ' + ui.values[1].toLocaleString() + '€');
      $('#kapitalmin').val(ui.values[0]);
      $('#kapitalmax').val(ui.values[1]);
    }
  });
  $('#kapitalbedarf').val($sliderRange.slider('values', 0).toLocaleString() + '€ - ' + $sliderRange.slider('values', 1).toLocaleString() + ' €');
};

/**
 * Slider für Startup einrichten
 */
const initSliderU = () => {
  const vars = generalUtility.getJsonFromHtml('.js-body-search #vars');
  const $sliderRange = $('#slider-range');

  $sliderRange.slider({
    min: 0,
    max: 5000000,
    step: 50000,
    value: vars.sliderValueU,
    slide: function (event, ui) {
      $('#kapitalbedarf').val(ui.value.toLocaleString() + ' €');
      $('#kapital').val(ui.value);
    }
  });

  $('#kapitalbedarf').val($sliderRange.slider('values', 0).toLocaleString() + '€');
};

export {
  init
};
